
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"var(--status-svg-color)","cx":"22","cy":"22","r":"22"}}),_c('g',{attrs:{"stroke":"#FFF","stroke-width":"2"}},[_c('path',{attrs:{"d":"M25 13h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M20 27l5-5-5-5M25 22H13"}})])])])
          )
        }
      }
    